import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

export default function TTSLogin() {
  const { girisYap } = useAuth();
  const [form, setForm]       = useState({ kul_adi: '', sifre: '' });
  const [hata, setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const giris = async e => {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);
    try {
      const k = await girisYap(form.kul_adi, form.sifre);
      const izinliRoller = ['onay_mercii', 'hakedis', 'frenusta', 'yonetici'];
      if (!izinliRoller.includes(k.rol)) {
        setHata('Bu portala erişim yetkiniz yok.');
      }
      // AuthContext state güncellenince App.js yeniden render eder
    } catch {
      setHata('Kullanıcı adı veya şifre hatalı.');
    }
    setYukleniyor(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', fontFamily: "'Barlow', sans-serif",
    }}>
      <div style={{ width: '100%', maxWidth: 380, padding: '0 20px' }}>

        {/* Logo alanı */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            fontFamily: "'Barlow Condensed', sans-serif", fontSize: 36, fontWeight: 900,
            letterSpacing: -1, color: 'var(--ink)',
          }}>TTS</div>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--muted)', marginTop: 4 }}>
            Tender Tracking System
          </div>
          <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 8 }}>
            Çalışkan Oto Servis
          </div>
        </div>

        {/* Form */}
        <div style={{
          background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 10, padding: 28,
        }}>
          <form onSubmit={giris}>
            <div style={{ marginBottom: 16 }}>
              <label style={lbl()}>Kullanıcı Adı</label>
              <input
                value={form.kul_adi}
                onChange={e => setForm(f => ({...f, kul_adi: e.target.value}))}
                placeholder="kullanici_adi"
                autoComplete="username"
                style={inp()}
                autoFocus
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={lbl()}>Şifre</label>
              <input
                type="password"
                value={form.sifre}
                onChange={e => setForm(f => ({...f, sifre: e.target.value}))}
                placeholder="••••••••"
                autoComplete="current-password"
                style={inp()}
              />
            </div>

            {hata && (
              <div style={{
                background: 'rgba(231,76,60,.08)', border: '1px solid rgba(231,76,60,.3)',
                borderRadius: 6, padding: '10px 14px', fontSize: 12,
                color: '#e74c3c', marginBottom: 16,
              }}>{hata}</div>
            )}

            <button
              type="submit"
              disabled={yukleniyor || !form.kul_adi || !form.sifre}
              style={{
                width: '100%', padding: '12px', border: 'none', borderRadius: 6,
                background: yukleniyor ? 'var(--muted)' : '#2980b9',
                color: 'white', fontFamily: "'Barlow Condensed', sans-serif",
                fontSize: 15, fontWeight: 800, letterSpacing: 1, cursor: 'pointer',
                textTransform: 'uppercase',
              }}
            >
              {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: 'var(--muted)' }}>
          OtoFlow · Çalışkan Oto Servis
        </div>
      </div>
    </div>
  );
}

const lbl = () => ({ display: 'block', fontSize: 11, fontWeight: 700, letterSpacing: .5, textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 6 });
const inp = () => ({ width: '100%', padding: '10px 12px', border: '1px solid var(--border2)', borderRadius: 6, fontSize: 13, fontFamily: "'Barlow', sans-serif", background: 'var(--surface)', color: 'var(--ink)', boxSizing: 'border-box' });
